<script>

export default {
	props: ['item'],
	computed: {
		showAditionalParams () {
			if (this.item.konto_destinacije === 'TV' || this.item.konto_destinacije === 'RV0KM' || this.item.konto_destinacije === 'ND') {
				return true;
			}
			return false;
		}
	}
}
</script>

<template>
	<b-card>
		<b-row class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Id:</b></b-col>
			<b-col sm="2">{{ item.id }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Kupec:</b></b-col>
			<b-col sm="2">{{ item.kupec }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Konto lastnika:</b></b-col>
			<b-col sm="2">{{ item.konto_lastnika }}</b-col>
		</b-row>
		<b-row class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Prodajni kanal:</b></b-col>
			<b-col sm="2">{{ item.prodajni_kanal }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Ime:</b></b-col>
			<b-col sm="2">{{ item.ime }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Konto destinacije:</b></b-col>
			<b-col sm="2">{{ item.konto_destinacije }}</b-col>
		</b-row>
		<b-row class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Tip kupca:</b></b-col>
			<b-col sm="2">{{ item.tip_kupca }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Email:</b></b-col>
			<b-col sm="2">{{ item.email }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Št. naročila vozila:</b></b-col>
			<b-col sm="2">{{ item.st_narocila_vozila }}</b-col>
		</b-row>
		<b-row class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Prodajalec:</b></b-col>
			<b-col sm="2">{{ item.koda_prod }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Telefon:</b></b-col>
			<b-col sm="2">{{ item.telefon_privatni }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Datum vnosa N.K.:</b></b-col>
			<b-col sm="2">{{ item.datum_vnosa_nk }}</b-col>
		</b-row>
		<b-row class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Dobava v koncesijo:</b></b-col>
			<b-col sm="2">{{ item.koncesija_datum }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>DVK Lokacija:</b></b-col>
			<b-col sm="2">{{ item.koncesija_lokacija }}</b-col>

			<b-col v-if="showAditionalParams" sm="2" class="text-sm-right"><b>Št. kilometrov:</b></b-col>
			<b-col v-if="showAditionalParams" sm="2">{{ item.st_kilometrov }}</b-col>
		</b-row>
		<b-row v-if="showAditionalParams" class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Datum prve registracije:</b></b-col>
			<b-col sm="2">{{ item.datum_prve_registracije | hr_date }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Prodamo ga lahko od:</b></b-col>
			<b-col sm="2">{{ item.datum_kdaj_ga_lahko_prodamo | hr_date }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Prodati ga moramo do:</b></b-col>
			<b-col sm="2">{{ item.datum_kdaj_ga_moramo_prodati | hr_date }}</b-col>

		</b-row>
		
		<b-row v-if="showAditionalParams" class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Prodajna cena:</b></b-col>
			<b-col sm="2" v-if="item.prodajna_cena != null && item.prodajna_cena > 0">{{ item.prodajna_cena | hr_money }}</b-col>
			<b-col sm="2" v-else > / </b-col>

			<b-col sm="2" class="text-sm-right"></b-col>
			<b-col sm="2"></b-col>

			<b-col sm="2" class="text-sm-right"></b-col>
			<b-col sm="2"></b-col>

		</b-row>
		
	</b-card>
</template>


// WEBPACK FOOTER //
// src/components/PodrobnostiVozilaCard.vue